import type { LucideIcon } from 'lucide-react';
import { useRecentRoute } from '@/hooks/useRecentRoute';
import styles from './PlaceholderPage.module.css';

interface PlaceholderPageProps {
  title: string;
  subtitle?: string;
  icon: LucideIcon;
  /** Recents-tracking label. Real placeholder routes (Reports,
   *  RFID Assignments, Audit Log) pass this; the 404 fallback
   *  omits it so bogus paths don't pollute recents. Empty string
   *  is the no-op signal — useRecentRoute skips empty labels. */
  recentLabel?: string;
}

export function PlaceholderPage({ title, subtitle, icon: Icon, recentLabel }: PlaceholderPageProps) {
  useRecentRoute(recentLabel ?? '');
  return (
    <div className={styles.page}>
      <div className={styles.header}>
        <div className={styles.headerIcon}>
          <Icon size={18} />
        </div>
        <div>
          <h1 className={styles.title}>{title}</h1>
          {subtitle && <p className={styles.subtitle}>{subtitle}</p>}
        </div>
      </div>

      <div className={styles.card}>
        <Icon size={40} className={styles.bigIcon} />
        <h2 className={styles.cardTitle}>Coming soon</h2>
        <p className={styles.cardText}>
          This section is scaffolded and will be built out in upcoming sessions.
        </p>
      </div>
    </div>
  );
}
